import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { VISIBILITY_PRIVATE, VISIBILITY_PUBLIC } from "@gettactic/api";
import { ToggleInput } from "@gettactic/components/src/form/ToggleInput";

/**
 * Toggles whether the reservation is private. When on, the schedule's
 * visibility is set to "private" so its details are hidden from other users;
 * when off it falls back to "public". The underlying API supports a third
 * "confidential" value which is intentionally not exposed here.
 */
export const ReserveFormVisibility: React.FC = () => {
  const { form } = useReserveForm();
  const visibility = form.watch("visibility");
  const isPrivate = visibility === VISIBILITY_PRIVATE;

  return (
    <ToggleInput
      label="Private reservation"
      description="Hide the details of this reservation from other users"
      togglePosition="right"
      verticalCenter
      size="sm"
      checked={isPrivate}
      onCheckedChange={(checked) =>
        form.setValue(
          "visibility",
          checked ? VISIBILITY_PRIVATE : VISIBILITY_PUBLIC
        )
      }
    />
  );
};
